<template>
  <div class="page">
    <Introduction />
    <div class="container" v-for="(item, index) in data" :key="index" >
      <div :id="name(index, item)">
        <DocSection :item="item" />
      </div>
    </div>
    <v-navigation-drawer
      v-model="displayNavMenu"
      right
      app
      fixed
      width="300"
    >
      <v-toolbar>
        <h2>API Reference</h2>
        <v-btn class="hidden-md-and-up" icon @click="displayNavMenu = false">
          <v-icon color="#777777">menu</v-icon>
        </v-btn>
      </v-toolbar>
      <v-list class="pt-5" dense>
        <div v-for="(item_title, index) in datatitles" :key="index">
          <div v-if="item_title.title">
            <v-list-group>
              <template v-slot:activator>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title @click="scrollTo(item_title.value)">
                      {{item_title.title}}
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
              <div v-for="(item, index) in datatitles" :key="index">
                <div v-if="item.proprietary == item_title.title">
                  <v-list-tile @click="scrollTo(item.value)">
                    <v-list-tile-content>
                      <v-list-tile-sub-title class="subTitle">{{item.subtitle}}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </div>
              </div>
            </v-list-group>
          </div>
        </div>
        <v-list-tile @click="$vuetify.goTo(0)">Back to the top</v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </div>
</template>

<script>
import Introduction from './Introduction'
import DataCollection from './data/index.js'
import DocSection from './DocSection'

export default {
  name:'MainDocumentation',
  components: { Introduction, DocSection },
  data() {
    return {
      datatitles: [],
      displayNavMenu: true,
      data: DataCollection
    }
  },
  methods: {
    name(index, item) {
      let id = ''
      if (item.title || item.subtitle) { id = `title-${index}` }
      return id
    },
    scrollTo(section_id) {
      this.$vuetify.goTo(`#title-${section_id}`)
    }
  },
  created() {
    let last_title

    this.data.forEach((item, index) => {
      if (item.title) {
        last_title = item.title

        this.datatitles.push({
          title: item.title,
          value: index
        })

        if (item.subtitle) {
          this.datatitles.push({
            proprietary: item.title,
            subtitle: item.subtitle,
            value: index
          })
        }

      } else if (item.subtitle) {
        this.datatitles.push({
          proprietary: last_title,
          subtitle: item.subtitle,
          value: index
        })
      }
    })
  },
  mounted() {
    this.$root.$on('display-nav-menu', () => this.displayNavMenu = true)
    if (this.$route.params.section_path) {
      setTimeout(() => {
        this.$vuetify.goTo(`#${this.$route.params.section_path}`)
      }, 1000)
    }
  }
}
</script>

<style scoped>
h2 {
  letter-spacing: -1px;
}
.subTitle {
  padding-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/documentation/MainDocumentation.vue